import React, { useState } from 'react';
import PropTypes from 'prop-types';
import {
  GatsbyImage,
  withArtDirection,
  getImage,
  getSrc,
} from 'gatsby-plugin-image';
import styled from 'styled-components';
import ButtonPlay from './buttonPlay.inline.svg';
import { Button, ButtonContainer } from '../Button';
import RichText from '../RichText';
import { StyledHeroCarouselItem } from './HeroCarouselStyle';
import VideoModal from '../VideoModal';
import { Heading } from 'grommet';

const HeroCarouselItem = (props) => {
  const { title, bodyText, backgroundImage, video, ctaLabel, ctaUrl } = props;

  const hasVideo = video?.file && video?.file.contentType.includes('video');
  const hasLink = ctaUrl && ctaLabel;

  const [showModal, setShowModal] = useState(false);

  const closeModal = () => {
    setShowModal(false);
  };

  const images = withArtDirection(getImage(backgroundImage.large), [
    {
      media: '(max-width: 1024px)',
      image: getImage(backgroundImage.small),
    },
  ]);

  const StyledRichText = styled(RichText)`
  h3 {
    font-size: 20px;
    line-height: 1.5;
    font-weight: normal;
    max-width: 640px;
  }
`;

  return (
    <StyledHeroCarouselItem>
      <div className="hero-carousel-item__image">
        <GatsbyImage alt="" image={images} />
      </div>
      <div className="hero-carousel-item__content">
        <div className="hero-carousel-item__content-inner">
          <Heading level="1" className="hero-carousel-item__title">
            {title}
          </Heading>
          <div className="hero-carousel-item__body">
            <StyledRichText richText={bodyText} />
          </div>

          <div className="hero-carousel-item__cta">
            <ButtonContainer>
              {hasVideo && !hasLink && (
                <Button
                  onDark
                  label={ctaLabel}
                  onClick={() => setShowModal(true)}
                  className={`nav-button hero-carousel-item__button`}
                  icon={<ButtonPlay />}
                />
              )}

              {hasLink && !hasVideo && (
                <Button
                  onDark
                  href={ctaUrl}
                  label={ctaLabel}
                  className={`nav-button hero-carousel-item__button`}
                />
              )}
            </ButtonContainer>
          </div>
        </div>
      </div>

      {hasVideo && (
        <VideoModal
          onRequestClose={closeModal}
          isOpen={showModal}
          videoSrc={hasVideo && video.file.url}
          videoPlaceholder={getSrc(backgroundImage.large)}
        />
      )}
    </StyledHeroCarouselItem>
  );
};

HeroCarouselItem.defaultProps = {
  video: null,
  videoPlaceholder: null,
  ctaLabel: null,
  ctaUrl: null,
};
HeroCarouselItem.propTypes = {
  title: PropTypes.string.isRequired,
  bodyText: PropTypes.object.isRequired,
  backgroundImage: PropTypes.object.isRequired,
  video: PropTypes.object,
  videoPlaceholder: PropTypes.object,
  ctaLabel: PropTypes.string,
  ctaUrl: PropTypes.string,
};

export default HeroCarouselItem;
